module.exports = __webpack_public_path__ + "img/wallet.1bf040d6.svg";